import React, { useRef, useEffect } from 'react';
import './Fireworks.css';
import * as confetti from 'canvas-confetti';

interface FireworksProps {
  duration?: number;
  burstCount?: number;
  colors?: string[];
  onComplete: () => void;
}

const Fireworks: React.FC<FireworksProps> = ({
  duration = 5000,
  burstCount = 10,
  colors = ['#ffffff', '#ff0000', '#ffff00', '#00ff00', '#0000ff'],
  onComplete,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const myConfetti = confetti.create(canvas, {
      resize: true,
      useWorker: false,
    });

    // Get the context *after* confetti.create()
    const context = canvas.getContext('2d');
    if (!context) return;

    const width = window.innerWidth;
    const height = window.innerHeight;

    canvas.width = width;
    canvas.height = height;

    const fire = () => {
      const particleCount = 200;
      const origin = { x: Math.random(), y: Math.random() - 0.1 };

      myConfetti({
        particleCount,
        spread: 160,
        origin,
        colors: colors,
        shapes: ['circle', 'star'],
      });
    };

    const interval = setInterval(fire, duration / burstCount);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      onComplete();
    }, duration);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [onComplete,duration, burstCount, colors]);

  return <canvas ref={canvasRef} className="fireworks-canvas" />;
};

export default Fireworks;